<template>
	<div ref="el" data-component="ribbon">
		<div class="inner">
			<h2 class="-title-3 -uppercase title">{{ title }}</h2>

			<div class="subtitle-main-cta-wrapper">
				<h3 class="-title-6 -uppercase subtitle">{{ subtitle }}</h3>
				<HyperLink v-if="mainCta" class="-footnote-1 -uppercase main-cta-btn" :to="mainCta.link" @mouseenter="handleMainCtaEnter" @mouseleave="handleMainCtaLeave">
					<span class="label">{{ mainCta.label }}</span>
				</HyperLink>
			</div>
		</div>

		<div class="inner">
			<h2 class="-title-3 -uppercase title">{{ title }}</h2>

			<div class="subtitle-main-cta-wrapper">
				<h3 class="-title-6 -uppercase subtitle">{{ subtitle }}</h3>
				<HyperLink v-if="mainCta" class="-footnote-1 -uppercase main-cta-btn" :to="mainCta.link" @mouseenter="handleMainCtaEnter" @mouseleave="handleMainCtaLeave">
					<span class="label">{{ mainCta.label }}</span>
				</HyperLink>
			</div>
		</div>
	</div>
</template>

<script setup>
import { HyperLink } from '~/components/core'
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	mainCta: { type: [Boolean, Object], default: false },
})

const el = ref(null)
const handleMainCtaEnter = () => el.value.classList.add('paused')
const handleMainCtaLeave = () => el.value.classList.remove('paused')
</script>

<style lang="scss" scoped>
[data-component='ribbon'] {
	position: relative;

	display: flex;
	height: 100%;
	overflow: hidden;

	background-color: var(--color-yellow);

	&.paused {
		.inner {
			animation-play-state: paused;
		}
	}

	.inner {
		display: flex;
		align-items: center;

		padding: rs(54);
		gap: rs(120);

		animation-name: loop;
		animation-iteration-count: infinite;
		animation-play-state: running;
		animation-duration: 18s;
		animation-timing-function: linear;

		@include max-screen($small) {
			animation-name: loop-horizontal;
		}

		@keyframes loop {
			0% {
				transform: translate3d(0, -100%, 0);
			}
			100% {
				transform: translate3d(0, 0, 0);
			}
		}

		@keyframes loop-horizontal {
			0% {
				transform: translate3d(0, 0, 0);
			}
			100% {
				transform: translate3d(-100%, 0, 0);
			}
		}
	}

	.title {
		white-space: nowrap;
		font-size: rs(230);
	}

	.subtitle-main-cta-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: rs(24);

		text-align: center;

		pointer-events: visible;

		transform: rotate(-90deg);

		@include max-screen($small) {
			transform: rotate(0deg);
		}

		.subtitle {
			white-space: pre-line;
		}

		.main-cta-btn {
			position: relative;

			display: flex;
			padding: rs(24) rs(6);
			border: 1px solid var(--color-darkBrown);
			border-radius: 100%;

			@include extend_hitbox(20);

			transition: color 0.25s ease(out-expo), background-color 0.25s ease(out-expo);

			@include max-screen($small) {
				padding: rs(6) rs(24);
			}

			@media (hover: hover) {
				&:hover {
					background-color: var(--color-darkBrown);
					color: var(--color-yellow);
				}
			}

			.label {
				position: relative;
			}
		}
	}
}
</style>
